<div class="location-options-dialog">
  <h2 mat-dialog-title i18n="@@bulk-add-locations.choose.option">
    Choose option to bulk-add locations
  </h2>

  <mat-dialog-content>
    <div class="container-flex-center options-container">
      <div class="container-flex option-card" (click)="onGeojsonFilesClick()">
        <h3 i18n="@@bulk-add-locations.geojson.title">GeoJson files</h3>
        <p i18n="@@bulk-add-locations.geojson.description">Upload multiple GeoJson files</p>
      </div>

      <div class="container-flex option-card" (click)="onManualEntryClick()">
        <h3 i18n="@@bulk-add-locations.manual.title">Manual entry</h3>
        <p i18n="@@bulk-add-locations.manual.description">
          Manually enter information on multiple locations
        </p>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <app-button-group>
      <app-button (pressed)="onClose()" type="ghost">
        <ng-container>{{ translations.cancel }}</ng-container>
      </app-button>
    </app-button-group>
  </mat-dialog-actions>
</div>
